/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { groups_CreateGroupRequest } from '../models/groups_CreateGroupRequest';
import type { groups_GroupChildcareShareResponse } from '../models/groups_GroupChildcareShareResponse';
import type { groups_GroupResponse } from '../models/groups_GroupResponse';
import type { groups_GroupWithLabelsResponse } from '../models/groups_GroupWithLabelsResponse';
import type { groups_ShareGroupRequest } from '../models/groups_ShareGroupRequest';
import type { groups_UpdateGroupRequest } from '../models/groups_UpdateGroupRequest';
import type { models_Childcare } from '../models/models_Childcare';
import type { models_GroupAudit } from '../models/models_GroupAudit';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GroupsService {
    /**
     * List groups
     * List groups with pagination
     * @param limit Limit
     * @param offset Offset
     * @returns groups_GroupResponse OK
     * @throws ApiError
     */
    public static getApiV1Groups(
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<groups_GroupResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                500: `Failed to list groups`,
            },
        });
    }
    /**
     * Create a group
     * Create a new group
     * @param group Group data
     * @returns groups_GroupResponse Created
     * @throws ApiError
     */
    public static postApiV1Groups(
        group: groups_CreateGroupRequest,
    ): CancelablePromise<groups_GroupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/groups',
            body: group,
            errors: {
                400: `Validation errors or invalid request format`,
                500: `Failed to create group`,
            },
        });
    }
    /**
     * Delete a group
     * Soft delete a group
     * @param id Group ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Groups(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing or invalid group ID`,
                404: `Group not found`,
                500: `Failed to delete group`,
            },
        });
    }
    /**
     * Get a group by ID
     * Get a group by ID
     * @param id Group ID
     * @returns groups_GroupResponse OK
     * @throws ApiError
     */
    public static getApiV1Groups1(
        id: string,
    ): CancelablePromise<groups_GroupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing or invalid group ID`,
                404: `Group not found`,
                500: `Failed to get group`,
            },
        });
    }
    /**
     * Update a group
     * Update an existing group
     * @param id Group ID
     * @param group Updated group data
     * @returns groups_GroupResponse OK
     * @throws ApiError
     */
    public static putApiV1Groups(
        id: string,
        group: groups_UpdateGroupRequest,
    ): CancelablePromise<groups_GroupResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/groups/{id}',
            path: {
                'id': id,
            },
            body: group,
            errors: {
                400: `Validation errors, invalid request format, or missing/invalid group ID`,
                404: `Group not found`,
                500: `Failed to update group`,
            },
        });
    }
    /**
     * Get group audit history
     * Get audit history for a group
     * @param id Group ID
     * @param limit Limit
     * @param offset Offset
     * @returns models_GroupAudit OK
     * @throws ApiError
     */
    public static getApiV1GroupsHistory(
        id: string,
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<models_GroupAudit>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups/{id}/history',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Share a group with a childcare
     * Create a sharing relationship between a group and a childcare
     * @param id Group ID
     * @param share Share request
     * @returns groups_GroupChildcareShareResponse Created
     * @throws ApiError
     */
    public static postApiV1GroupsShare(
        id: string,
        share: groups_ShareGroupRequest,
    ): CancelablePromise<groups_GroupChildcareShareResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/groups/{id}/share',
            path: {
                'id': id,
            },
            body: share,
            errors: {
                400: `Missing or invalid group ID, or validation error`,
                404: `Group not found`,
                409: `Group already shared with childcare`,
                500: `Failed to share group`,
            },
        });
    }
    /**
     * Unshare a group from a childcare
     * Remove a sharing relationship between a group and a childcare
     * @param id Group ID
     * @param childcareId Childcare ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1GroupsShare(
        id: string,
        childcareId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/groups/{id}/share/{childcareId}',
            path: {
                'id': id,
                'childcareId': childcareId,
            },
            errors: {
                400: `Missing or invalid group ID or childcare ID`,
                404: `Group not found or not shared`,
                500: `Failed to unshare group`,
            },
        });
    }
    /**
     * Get childcares a group is shared with
     * Retrieve all childcares that a specific group is shared with
     * @param id Group ID
     * @returns models_Childcare OK
     * @throws ApiError
     */
    public static getApiV1GroupsSharedChildcares(
        id: string,
    ): CancelablePromise<Array<models_Childcare>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups/{id}/shared-childcares',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing or invalid group ID`,
                404: `Group not found`,
                500: `Failed to get shared childcares`,
            },
        });
    }
    /**
     * Get a group with its assigned labels
     * Get a group by ID including all assigned labels
     * @param id Group ID
     * @returns groups_GroupWithLabelsResponse OK
     * @throws ApiError
     */
    public static getApiV1GroupsWithLabels(
        id: string,
    ): CancelablePromise<groups_GroupWithLabelsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups/{id}/with-labels',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing or invalid group ID`,
                404: `Group not found`,
                500: `Failed to get group with labels`,
            },
        });
    }
    /**
     * List groups by childcare
     * List groups that belong to a specific childcare
     * @param childcareId Childcare ID
     * @param limit Limit
     * @param offset Offset
     * @returns groups_GroupResponse OK
     * @throws ApiError
     */
    public static getApiV1GroupsChildcare(
        childcareId: string,
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<groups_GroupResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups/childcare/{childcareId}',
            path: {
                'childcareId': childcareId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Missing childcare ID`,
                500: `Failed to list groups`,
            },
        });
    }
    /**
     * List groups by organization and childcare
     * List both org-wide groups and childcare-specific groups
     * @param childcareId Childcare ID
     * @param limit Limit
     * @param offset Offset
     * @returns groups_GroupResponse OK
     * @throws ApiError
     */
    public static getApiV1GroupsOrgAndChildcare(
        childcareId: string,
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<groups_GroupResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups/org-and-childcare/{childcareId}',
            path: {
                'childcareId': childcareId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Missing childcare ID`,
                500: `Failed to list groups`,
            },
        });
    }
    /**
     * Get groups shared with a childcare
     * Retrieve all groups that are shared with a specific childcare
     * @param childcareId Childcare ID
     * @param limit Limit
     * @param offset Offset
     * @returns groups_GroupResponse OK
     * @throws ApiError
     */
    public static getApiV1GroupsSharedWithChildcare(
        childcareId: string,
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<groups_GroupResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups/shared-with-childcare/{childcareId}',
            path: {
                'childcareId': childcareId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Missing childcare ID`,
                500: `Failed to get shared groups`,
            },
        });
    }
}
